import axios from './index';

class BullionConfigApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      unit: data.unit,
      type: data.type,
      customer_max_buy: Number(data.customer_max_buy),
      customer_max_sell: Number(data.customer_max_sell),
      buy_price_percentage_deviation: Number(
        data.buy_price_percentage_deviation
      ),
      sell_price_percentage_deviation: Number(
        data.sell_price_percentage_deviation
      ),
      exchange_price_percentage_deviation: Number(
        data.exchange_price_percentage_deviation
      ),
      threshold_sell: Number(data.threshold_sell),
      threshold_buy: Number(data.threshold_buy),
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.unit) request.unit = data.unit;
    if (data.type) request.type = data.type;
    if (data.buy_price_percentage_deviation)
      request.buy_price_percentage_deviation = Number(
        data.buy_price_percentage_deviation
      );
    if (data.sell_price_percentage_deviation)
      request.sell_price_percentage_deviation = Number(
        data.sell_price_percentage_deviation
      );
    if (data.exchange_price_percentage_deviation)
      request.exchange_price_percentage_deviation = Number(
        data.exchange_price_percentage_deviation
      );
    if (data.threshold_buy) request.threshold_buy = Number(data.threshold_buy);
    if (data.threshold_sell)
      request.threshold_sell = Number(data.threshold_sell);
    // console.log("Request formed", request);
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (configId) => {
    return axios.delete(`${base}/${configId}`);
  };
}

let base = '/dashboard/bullion-config';

export default BullionConfigApi;
